import { useState, useEffect, useCallback } from 'react';

import DynaLoader from './DynaLoader';

import TokenList from './TokenList';

import { fetchOwnedTokenIds, isAccountConnected, getSigner } from '../utils/BlockchainAPI';
import { isWalletAvailable } from '../utils/WalletProviders';
import DynaSpan from './DynaSpan';
import MetaMaskLink from './MetaMaskLink';
import { handleError } from '../utils/ErrorHandler';
import * as Errors from '../utils/ErrorMessages';

const YourStripesComponent = () => {
  const [loading, setLoading] = useState(true);
  const [tokenIds, setTokenIds] = useState<any[]>([]);
  const [hasWallet, setHasWallet] = useState<boolean | undefined>(undefined);

  const fetchTokens = useCallback(async () => {
    console.log("[YourStripesComponent] Fetching tokens...");

    try {
      if (!(await isWalletAvailable())) {
        setLoading(false);
        setHasWallet(false);
        return;
      }

      const connected = await isAccountConnected();
      console.log("[YourStripesComponent] Connected: " + connected);
      if (connected === false) {
        setLoading(false);
        setHasWallet(false);
        return;
      }

      const signer = await getSigner();
      const account = await signer.getAddress();

      const tokensList = await fetchOwnedTokenIds(account);

      setLoading(false);
      setTokenIds(tokensList);

    } catch (err: any) {

      if (err?.message === Errors.DS_NO_ETH_WALLET) {
        setLoading(false);
        setHasWallet(false);
      } else {
        handleError(err);
        setHasWallet(true);
        setLoading(false);
        setTokenIds([]);
      }
    }
  }, []);

  useEffect(() => {
    fetchTokens();
  }, [fetchTokens]);

  console.log("RENDER TOKEN IDS: " + tokenIds);
  if (loading === true) {
    return (
      <div className="content">
        <h1>Your <DynaSpan /> NFTs</h1>
        <DynaLoader variant="block" />
      </div>
    );
  } else if (hasWallet !== undefined && hasWallet === false) {
    return (
      <div className="content">
        <h1>Your <DynaSpan /> NFTs</h1>
        A crypto wallet is required to view your <DynaSpan />. Install <MetaMaskLink />.
      </div>
    );

  } else if (tokenIds === null || tokenIds.length === 0) {
    return (
      <div className="content">
        <h1>Your <DynaSpan /> NFTs</h1>
        You have no DynaStripes yet.
      </div>
    );
  } else {
    return (
      <div className="content">
        <h1>Your <DynaSpan /> NFTs</h1>
        <TokenList tokens={tokenIds} />
      </div>
    );
  }
}

export default YourStripesComponent;